import Vue from 'vue'
import Router from 'vue-router'
import Index from '../pages/home/index.vue'
import About from '../pages/home/About.vue'
import Solution from '../pages/home/Solution.vue'
import SuccessCases from '../pages/home/SuccessCases.vue'
import Teams from '../pages/home/Teams.vue'
import Layout from '../pages/layout/index.vue'

const originalPush = Router.prototype.push

Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

// 初始化路由
const routes = [
  {
    path: '',
    component: Layout,
    name: 'container',
    redirect: 'index',
    meta: {
      requiresAuth: true,
      name: '首页'
    },
    children: [
      {
        path: '',
        component: Index,
        name: 'index',
        meta: {
          name: '首页',
          icon: 'icon-name'
        }
      },
      {
        path: 'index',
        component: Index,
        name: 'index',
        meta: {
          name: '首页',
          icon: 'icon-name'
        }
      },
      {
        path: 'about',
        component: About,
        name: 'about',
        meta: {
          name: '关于我们',
          icon: 'icon-name'
        }
      },
      {
        path: 'solution',
        component: Solution,
        name: 'solution',
        meta: {
          name: '解决方案',
          icon: 'icon-name'
        }
      },
      {
        path: 'teams',
        component: Teams,
        name: 'teams',
        meta: {
          name: 'Teams',
          icon: 'icon-name'
        }
      },
      {
        path: 'successCases',
        component: SuccessCases,
        name: 'successCases',
        meta: {
          name: '成功案例',
          icon: 'icon-name'
        }
      }
    ]
  }
]

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js